import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  text: 'Me sorprendió lo claro y organizado que está todo el contenido. Sentí que realmente pude comprender conceptos que antes veía muy complejos.',
  name: 'Carolina M.',
  city: 'Rosario'
}, {
  text: 'Lo empecé por interés personal y terminé incorporando herramientas muy útiles para aplicar todos los días.',
  name: 'Valeria S.',
  city: 'Buenos Aires'
}, {
  text: 'La estructura, los protocolos y los casos reales hacen que se sienta una formación muy profesional.',
  name: 'Ana P.',
  city: 'Mendoza'
}];
function TestimonialCard({
  text,
  name,
  city,
  index
}: {
  text: string;
  name: string;
  city: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-[#f5efe0] border border-[#2d3f2a]/10 rounded-2xl p-6 flex flex-col gap-3 transition-all duration-500 hover:border-[#5a6b3f]/30 hover:shadow-md ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-323">
      <div className="flex gap-0.5" data-id="element-324">
        {Array.from({
        length: 5
      }).map((_, i) => <span key={i} className="text-[#b8860b] text-sm" data-id="element-325">
            ★
          </span>)}
      </div>
      <p className="text-[#3a4a35] text-sm md:text-base leading-relaxed italic flex-grow" data-id="element-326">
        "{text}"
      </p>
      <div className="flex items-center gap-3 pt-3 border-t border-[#2d3f2a]/10" data-id="element-327">
        <div className="w-9 h-9 rounded-full bg-[#5a6b3f]/15 border border-[#5a6b3f]/25 flex items-center justify-center flex-shrink-0" data-id="element-328">
          <span className="text-[#2d3f2a] font-bold text-xs" data-id="element-329">
            {name.split(' ').map(n => n[0]).join('')}
          </span>
        </div>
        <div data-id="element-330">
          <p className="text-[#1e3a1e] text-sm font-bold leading-tight" data-id="element-331">
            {name}
          </p>
          <p className="text-[#5a5040] text-xs" data-id="element-332">{city}</p>
        </div>
      </div>
    </div>;
}
export function TestimonialsSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#faf3e3] py-5 md:py-10 px-4 sm:px-6 border-t border-[#2d3f2a]/5" data-id="element-333">
      <div className="container mx-auto max-w-5xl" data-id="element-334">
        <div ref={ref} className={`reveal text-center mb-8 ${vis ? 'is-visible' : ''}`} data-id="element-335">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1e3a1e]" data-id="element-336">
            Experiencias de alumnos
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-337">
          {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-338" />)}
        </div>
      </div>
    </section>;
}